import React, { useEffect, useRef } from 'react';

const ORDER_OPTIONS = [
  { id: 'NEWEST', label: 'Newest' },
  { id: 'FEATURED_AT', label: 'Featured date' },
  { id: 'VOTES', label: 'Votes' },
  { id: 'RANKING', label: 'Ranking' },
];

const fieldClass =
  'px-2 py-1.5 text-[13px] border border-paper-strong rounded-[4px] bg-white disabled:opacity-50';

function ScrapeProductHuntModal({
  open,
  onClose,
  prefs,
  onPrefsChange,
  onScrape,
  running,
}) {
  const dialogRef = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open) return null;

  const set = (patch) => onPrefsChange({ ...prefs, ...patch });

  const handleScrape = () => {
    onScrape(prefs);
    onClose();
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-ink/20" onClick={onClose} />
      <div
        ref={dialogRef}
        role="dialog"
        aria-labelledby="scrape-ph-title"
        className="relative bg-white rounded-[6px] shadow-popover border border-paper-line w-full max-w-md overflow-hidden"
      >
        <div className="px-5 pt-4 pb-3 border-b border-paper-line flex items-start justify-between gap-3">
          <div>
            <h2
              id="scrape-ph-title"
              className="text-[15px] font-semibold tracking-tight text-ink"
            >
              Scrape Product Hunt
            </h2>
            <p className="text-[12px] text-ink-faint mt-0.5">
              New domains land in the table. Date is launches posted that day.
            </p>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="text-ink-faint hover:text-ink p-1"
            aria-label="Close"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              className="w-4 h-4"
            >
              <path d="M18 6L6 18M6 6l12 12" />
            </svg>
          </button>
        </div>

        <div className="px-5 py-4 grid grid-cols-2 gap-3">
          <label className="text-[12px] text-ink-muted flex flex-col gap-1">
            Date
            <input
              type="date"
              value={prefs.postedBefore}
              disabled={running}
              onChange={(e) => set({ postedBefore: e.target.value })}
              className={fieldClass}
            />
          </label>
          <label className="text-[12px] text-ink-muted flex flex-col gap-1">
            Order
            <select
              value={prefs.order}
              disabled={running}
              onChange={(e) => set({ order: e.target.value })}
              className={fieldClass}
            >
              {ORDER_OPTIONS.map((o) => (
                <option key={o.id} value={o.id}>
                  {o.label}
                </option>
              ))}
            </select>
          </label>
          <label className="text-[12px] text-ink-muted flex flex-col gap-1">
            Topic
            <input
              type="text"
              value={prefs.topic}
              disabled={running}
              onChange={(e) => set({ topic: e.target.value })}
              placeholder="artificial-intelligence"
              className={fieldClass}
            />
          </label>
          <label className="text-[12px] text-ink-muted flex flex-col gap-1">
            Limit
            <input
              type="number"
              min={1}
              max={300}
              value={prefs.limit}
              disabled={running}
              onChange={(e) => set({ limit: Number(e.target.value) || 120 })}
              className={fieldClass}
            />
          </label>
          <label className="text-[12px] text-ink-muted flex items-end gap-2 pb-1.5">
            <input
              type="checkbox"
              checked={prefs.featured}
              disabled={running}
              onChange={(e) => set({ featured: e.target.checked })}
              className="rounded border-paper-strong"
            />
            <span>Featured only</span>
          </label>
        </div>

        <div className="px-5 py-3 border-t border-paper-line flex items-center justify-end gap-2 bg-paper-soft">
          <button
            type="button"
            onClick={onClose}
            className="text-[13px] px-3 py-1.5 rounded-[4px] border border-paper-strong bg-white hover:bg-wash"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={handleScrape}
            disabled={running}
            className="text-[13px] px-3 py-1.5 rounded-[4px] bg-cta text-white hover:bg-cta-hover disabled:opacity-40"
          >
            {running ? 'Scraping…' : 'Scrape'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default ScrapeProductHuntModal;
export { ORDER_OPTIONS };
